// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hQz8","colBig":"styles_colBig__3YAaE","colSmall":"styles_colSmall__2SFr_","shopifyNameWrapper":"styles_shopifyNameWrapper__25leO"};